import React from 'react';
import PropTypes from 'prop-types';
// import { SeButton, SeIcon } from '@se/web-ui -react';
import './button.css';

const Button = ({ label, type, onHandleClick, iconName, disabled }) => {

  const handleActionClick = (action) => {
    setTimeout(() => {
      onHandleClick(action);
    }, 100)    
  }

  return (
    <>
      {type === 'icon' ? (
        <se-button data-testid='iconButton' onClick={() => disabled? '' : handleActionClick(label)} option={'inherit'} class='iconAlign' disabled={disabled} >
          <se-icon size="small">{iconName}</se-icon>
        </se-button>
      ) : (
        <se-button disabled={disabled} option='primary' data-testid='button' onClick={() => disabled ? '' : handleActionClick(label)} className='labelbutton'>
          <label className='text'>{label}</label>
        </se-button>
      )}
    </>
  );
};

export default Button;

Button.propTypes = {
  label: PropTypes.string.isRequired,
  type: PropTypes.string
};
